
export default {
    common: {
      buttons: {
        add: 'Add',
        update: 'Edit',
        delete: 'Delete',
        query: 'Query',
        reset: 'Reset',
        submit: 'Submit',
        export: 'Export',
        import: 'Import',
        importConfire: 'Import',
        unValid: 'validate failed',
        template: 'Download Template',
        view: 'View',
        save: 'Save',
        cancel: 'Cancel',
        opt: 'Operation',
        upload: 'Upload',
        detail: 'Detail',
        clear: 'Clear',
        warningConfig: 'Config',
        waveform: 'Waveform',
      },
      message: {
        pleaseInput: 'Please check the input content',
        pleaseSelect: 'Please select',
        addSuccess: 'Add success',
        updateSuccess: 'Update success',
        deleteSuccess: 'Delete success',
        querySuccess: 'Query success',
        saveSuccess: 'Save success',
        uploadSuccess: 'Upload success',
        noData: 'No Datas ...'
      },
      pagination: {
        "layout": "prev, pager, next, sizes, total",
        "prev": "prev",
        "next": "next",
        "total": "Total {total} items"
    }
    },
    pages: {
      loginLabel: {
        title: 'Welcome to Login',
        usernameLabel: 'Account',
        passwordLabel: 'Password',
        loginButton: 'Login',
      },
      orgFormLabel: {
        parentName: 'superior enterprise',
        companyName: 'enterprise name',
      },
      sysParams: {
        title: 'System Parameters',
        paramKey: 'Parameter KEY',
        paramName: 'Parameter Name',
        paramDesc: 'Parameter Description',
        paramValueZh: 'Parameter Value (Chinese)',
        paramValueEn: 'Parameter Value (English)',
      },
      home: {
        electric: 'Lightning Warning',
        location: 'Lightning Monitoring',
        peak: 'Lightning Peak',
        resistance: 'Ground Resistance',
        protection: 'Lightning Protection',
        rod: 'Lightning Rod',
        total: 'Total',
        onlineRate: 'Online Rate',
        onlineTitle: 'Online',
        unlineTitle: 'Offline',
        warningRate: 'Alarm Rate',
        nomalTitle: 'Normal',
        warningTitle: 'Warning',
      },
      deviceMgr: {
        title: 'Device Manage',
        dialogTitle: 'Device Information',
        type: 'Device Type',
        companyName: 'Company Name',
        deviceId: 'Device ID',
        deviceName: 'Device Name',
        status: 'Status',
        deviceType: 'Model',
        lon: 'Longitude',
        lat: 'Latitude',
        location: 'Address',
        produceDate: 'Manufacture Date',
        installDate: 'Install Date',
        protocol: 'Protocol',
        imgUrl: 'Device Img',
        memo: 'Memo',
        warningCancelTime: 'Warning Clear Time (min)',
        noWarningTime: 'No Warning Time(min)',
        r1: 'Inner Radius',
        r2: 'Middle Radius',
        r3: 'Outer Radius',
        isValid: 'Is Valid',
        msg: 'Validation Message',

        
        quantity_standard: 'Battery Voltage Standard',
        quantity_warning: 'Battery Voltage Warning',
        resistance_standard: 'Protective Resistance Standard',
        resistance_warning: 'Protective Resistance Warning',
        voltage_standard: 'Protective Ground Voltage Standard',
        voltage_warning: 'Protective Ground Voltage Warning',
        resistance2_standard: 'Working Resistance Standard',
        resistance2_warning: 'Working Resistance Warning',
        voltage2_standard: 'Working Ground Voltage Standard',
        voltage2_warning: 'Working Ground Voltage Warning',
        resistance3_standard: 'Lightning Resistance Standard',
        resistance3_warning: 'Lightning Resistance Warning',
        voltage3_standard: 'Lightning Ground Voltage Standard',
        voltage3_warning: 'Lightning Ground Voltage Warning',
        resistance4_standard: 'Static Resistance Standard',
        resistance4_warning: 'Static Resistance Warning',
        voltage4_standard: 'Static Ground Voltage Standard',
        voltage4_warning: 'Static Ground Voltage Warning',
        resistance5_standard: 'Shielding Resistance Standard',
        resistance5_warning: 'Shielding Resistance Warning',
        voltage5_standard: 'Shielding Ground Voltage Standard',
        voltage5_warning: 'Shielding Ground Voltage Warning',
      },
      electric: {
        warnintTimes: 'Warning Times',
        online: 'Online',
        exeception: 'Exception',
        offline: 'Offline',
        normal: 'Normal',
        warning: 'Warning',
        unknown: 'Unknown',
        total: 'Total',
        hour: 'Hour',
        day: 'Day',
        offTimes: 'Offline Times',
        warningTimes: 'Warning Times',
        warningDistribution: 'Warning Distribution',
        noWarning: 'No Warning',
        level1: 'Level1',
        level2: 'Level2',
        level3: 'Level3',
        warningDeal: 'Warning Deal',
        offlineRate: 'Offline Rate',
        warningRate: 'Warning Rate',
        
        latestWarning: 'Warning',
        deviceId: 'Device ID',
        deviceType: 'Device Type',
        deviceName: 'Device Name',
        dataTime: 'Update Time',
        datas: 'Datas',
        companyName: 'Company',
        location: 'Address',
        lonlat: 'Lon,Lat',
        installDate: 'Install Date',
        status: 'Status',
        updateTime: 'Update Time',
        queryBtn: 'Device Query',
        warningBtn: 'Warning Record',
        historyBtn: 'History Data',
        repairBtn: 'Repair Record',
        deviceList: 'Device List',
        latestData: 'Latest Data',
        intensity: 'Intensity',
        warningGrade: 'Grade',
        temp: 'Temperature',
        precipitation: 'Precipitation',
        rh: 'Humidity',
        pressure: 'Pressure',
        windSpeed: 'Wind Speed',
        windDirection: 'Wind Direction',
        more: 'More Device',

        
        warningTime: 'Warning Time',
        warningItem: 'Warning Item',
        warningData: 'Warning Data',
        warningLevel: 'Warning Level',
        warningDesc: 'Warning Description',

        
        electricity: 'Lightning Current',
        lighting_count: 'Lightning Count',
        lighting_count1: 'Strike Count',
        tilt: 'Tilt',
        resistance: 'Ground Resistance',
        voltage: 'Ground Voltage',
        spd1_temp: 'SPD1 Temperature',
        spd1_leakage_all: 'SPD1 Leakage Current',
        surge_count: 'Surge Count',
        quantity: 'Battery Quantity',
      },
      deviceMaintain: {
        title: 'Device Maintenance',
        deviceName: 'Device Name',
        workOrderName: 'Order Name',
        level: 'Order Level',
        level10: 'Fault',
        level20: 'Inspection',
        level30: 'Repair',
        description: 'Description',
        principal: 'responsor',
        type: 'Order Type',
        status: 'Order Status',
        createTime: 'Create Time',
        deviceId: 'Device ID',
        restoreTime: 'Repair Time',
        add: 'Add Maintenance Order',
        edit: 'Edit Maintenance Order',
        query: 'Query',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        confirmDelete: 'Are you sure to delete this order?',
        successSave: 'Saved successfully',
        successDelete: 'Deleted successfully',
        timeRange: 'Time Range',
        startTime: 'Start Date',
        endTime: 'End Date'
      }
    }
  }